<template>
  <div class="swiper-box">
    <van-notice-bar
      left-icon="gem-o"
      scrollable
      :text="text"
      speed="40"
    />
    <van-swipe :autoplay="3000">
      <van-swipe-item>
        <img class="image" src="@/assets/images/mobile/swipe2.png">
      </van-swipe-item>
      <van-swipe-item>
        <img class="image" src="@/assets/images/mobile/swipe1.png">
      </van-swipe-item>
      <van-swipe-item>
        <img class="image" src="@/assets/images/mobile/swipe3.png">
      </van-swipe-item>
      <van-swipe-item>
        <img class="image" src="@/assets/images/mobile/swipe4.png">
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  name: "Swiper",
  data () {
    return {
      text: '技术创新是企业发展的动力，质量是企业的生命，服务是“心虔志诚，客户至上。(Technological innovation is the driving force for enterprise development, quality is the life of the enterprise, and service is "devout and sincere, customer first")'
    }
  }
}
</script>

<style lang="less" scoped>
.swiper-box {
  width: 100%;
  margin-top: 0.16rem;
  .image {
    width: 100%;
    height: 100%;
  }
  /deep/ .van-swipe__track {
    height: 4.7rem;
  }
  /deep/ .van-swipe__indicators {
    position: absolute;
    bottom: 0.1rem;
  }
  /deep/ .van-swipe__indicator, .van-swipe__indicator--active {
    width: 0.2rem;
    height: 0.2rem;
    margin-left: 0.16rem;
  }
  /deep/ .van-notice-bar {
    height: 1rem;
  }
  /deep/ .van-notice-bar__content {
    font-size: 0.4rem;
  }
  /deep/ .van-notice-bar__left-icon {
    margin-left: 0.24rem;
    margin-right: 0.16rem;
    font-size: 0.4rem;
  }
}
</style>
